import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  getIsCreditReportNoRecordFoundSelector,
  getIsCreditReportUnavailableSelector,
} from '../../../../../../selectors/sharedReports';
import { isLandlordIdVerifiedSelector } from '../../../../../../selectors';
import ScreeningReportNavLink from '../ScreeningReportNavLink/ScreeningReportNavLink';
import CreditReportNavigation from './CreditReportNavigation';
import { CREDIT } from '../../../../../../constants/overviewSections';
import {
  REPORT_STATUS_NO_RECORD_FOUND,
  REPORT_STATUS_NOT_AVAILABLE,
} from '../../../../../../constants/statusConstants';
import CreditReportGeneralAlert from './CreditReportGeneralAlert';
import { useListingUser } from '../../../../../../hooks/useListingUser';
import { emitCreditReportLinkEvent } from '../../../../../../../client/analytics/clickstreamEvents';
export default function CreditReportNavLink({
  applicant,
  isCustomLoading,
  customNavigationCallback,
  setCustomNavigationCallback,
}) {
  const { user, listing } = useListingUser();
  const { userId: applicantId } = applicant;
  const isIdVerified = useSelector(isLandlordIdVerifiedSelector);
  const isCreditReportUnavailable = useSelector(getIsCreditReportUnavailableSelector(applicantId));
  const isCreditReportNoRecordFound = useSelector(getIsCreditReportNoRecordFoundSelector(applicantId));

  const reportStatus = isCreditReportNoRecordFound
    ? REPORT_STATUS_NO_RECORD_FOUND
    : isCreditReportUnavailable
      ? // Override if call to retrieve shared reports was made and failed.
        REPORT_STATUS_NOT_AVAILABLE
      : // Otherwise, get report status from user statuses.
        applicant?.creditInfo?.status;

  return (
    <>
      <CreditReportNavigation
        {...{
          applicantId,
          customNavigationCallback,
          setCustomNavigationCallback,
        }}
      />
      <ScreeningReportNavLink
        applicant={applicant}
        reportStatus={reportStatus}
        sectionComment={applicant.creditReportComment}
        trackNavLinkClick={() => emitCreditReportLinkEvent(listing, user)}
        title="Credit report"
        sectionId={CREDIT}
        alert={<CreditReportGeneralAlert {...{ applicant }} />}
        {...{
          ...(isIdVerified && {
            isCustomLoading,
            setCustomNavigationCallback,
          }),
        }}
      />
    </>
  );
}

CreditReportNavLink.propTypes = {
  applicant: PropTypes.shape({
    creditReportComment: PropTypes.string.isRequired,
    creditInfo: PropTypes.shape({
      status: ScreeningReportNavLink.propTypes.reportStatus,
    }),
    userId: PropTypes.string.isRequired,
  }).isRequired,
  isCustomLoading: PropTypes.bool.isRequired,
  customNavigationCallback: PropTypes.func,
  setCustomNavigationCallback: PropTypes.func.isRequired,
};
